import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../../messages/messagesActions";
import {
  IAccountsPayableCheque,
  initialAccountingAccountsPayableChequeState,
} from "./AccountsPayableCheque.types";

export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_PROGRESS =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_PROGRESS";
export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_SUCCESS =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_SUCCESS";
export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_FAILURE =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_FAILURE";

export const fetchAccountingAccountsPayableChequeProgress = () =>
  action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_PROGRESS);

export const fetchAccountingAccountsPayableChequeSuccess = (
  data: IAccountsPayableCheque
) => action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_SUCCESS, { data });

export const fetchAccountingAccountsPayableChequeFailed = (
  errorMessage: string
) => action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_FAILURE, { errorMessage });

export const fetchAccountingAccountsPayableChequeAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingAccountsPayableChequeProgress());
      const res = await api.get(
        `/accounting/get-account-accounts-payable-cheque`
      );
      const data: IAccountsPayableCheque[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingAccountsPayableChequeSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingAccountsPayableChequeSuccess(
            initialAccountingAccountsPayableChequeState["data"]
          )
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingAccountsPayableChequeFailed(
          "Something went to be wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingAccountsPayableChequeAysnc =
  (
    data: IAccountsPayableCheque,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress())
      await api.post("/accounting/edit-account-accounts-payable-cheque", {
        ...data,
      });
      const message = "Accounts Payable Cheque saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted())
    }
  };

export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_PROGRESS =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_PROGRESS";
export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_SUCCESS =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_SUCCESS";
export const FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_FAILURE =
  "FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_FAILURE";

export const fetchAccountingAccountsPayableChequeListProgress = () =>
  action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_PROGRESS);

export const fetchAccountingAccountsPayableChequeListSuccess = (
  data: IAccountsPayableCheque[]
) => action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_SUCCESS, { data });

export const fetchAccountingAccountsPayableChequeListFailed = (
  errorMessage: string
) =>
  action(FETCH_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE_LIST_FAILURE, {
    errorMessage,
  });

export const fetchAccountingAccountsPayableChequeListAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingAccountsPayableChequeListProgress());
      const res = await api.get(
        `/accounting/get-account-accounts-payable-cheque`
      );
      const data: IAccountsPayableCheque[] = res.data.data;
      dispatch(fetchAccountingAccountsPayableChequeListSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchAccountingAccountsPayableChequeListFailed(
          "Something went to be wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE =
  "CLEAR_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE";
export const clearAccountingAccountsPayableCheque = () =>
  action(CLEAR_ACCOUNTING_ACCOUNTS_PAYABLE_CHEQUE);
